import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Generate session ID for cart
export const getSessionId = () => {
  let sessionId = localStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};

// Products API
export const getProducts = async (params = {}) => {
  try {
    const response = await axios.get(`${API}/products`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const getProductCount = async (params = {}) => {
  try {
    const response = await axios.get(`${API}/products/count`, { params });
    return response.data.count;
  } catch (error) {
    console.error('Error fetching product count:', error);
    throw error;
  }
};

export const getProduct = async (productId) => {
  try {
    const response = await axios.get(`${API}/products/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

// Cart API
export const getCart = async () => {
  const sessionId = getSessionId();
  try {
    const response = await axios.get(`${API}/cart/${sessionId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cart:', error);
    throw error;
  }
};

export const addToCart = async (productId, quantity = 1, recaptchaToken = '') => {
  const sessionId = getSessionId();
  try {
    const response = await axios.post(`${API}/cart/add`, null, {
      params: { session_id: sessionId, product_id: productId, quantity, recaptcha_token: recaptchaToken }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
};

export const updateCartItem = async (productId, quantity) => {
  const sessionId = getSessionId();
  try {
    const response = await axios.put(`${API}/cart/update`, null, {
      params: { session_id: sessionId, product_id: productId, quantity }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating cart:', error);
    throw error;
  }
};

export const removeFromCart = async (productId) => {
  const sessionId = getSessionId();
  try {
    const response = await axios.delete(`${API}/cart/remove/${sessionId}/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing from cart:', error);
    throw error;
  }
};

export const clearCart = async () => {
  const sessionId = getSessionId();
  try {
    const response = await axios.delete(`${API}/cart/clear/${sessionId}`);
    return response.data;
  } catch (error) {
    console.error('Error clearing cart:', error);
    throw error;
  }
};

// Orders API
export const createOrder = async (orderData) => {
  try {
    const response = await axios.post(`${API}/orders`, orderData);
    return response.data;
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};

export const getOrder = async (orderNumber) => {
  try {
    const response = await axios.get(`${API}/orders/track/${orderNumber}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching order:', error);
    throw error;
  }
};

// Gallery API
export const getGallery = async () => {
  try {
    const response = await axios.get(`${API}/gallery`);
    return response.data;
  } catch (error) {
    console.error('Error fetching gallery:', error);
    throw error;
  }
};

// Testimonials API
export const getTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

// Contact API
export const submitContact = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

export const getDownload = async (slug) => {
  try {
    const response = await axios.get(`${API}/downloads/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching download:', error);
    throw error;
  }
};

export const downloadFile = async (slug, password = '') => {
  try {
    const response = password
      ? await axios.post(`${API}/downloads/${slug}/file`, { password }, { responseType: 'blob' })
      : await axios.get(`${API}/downloads/${slug}/file`, { responseType: 'blob' });
    return response;
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};
